import React from 'react';
import { Row, Col, Space, Typography, Select } from 'antd';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import classes from './Style.module.scss';
import { DataType, useMasterData } from 'app/providers/StaticProvider';

const FIELD_NAME = {
  CRITICAL_LEVEL: 'criticalLevel',
  MAJOR_LEVEL: 'criticalMajorLevel',
  MINOR_LEVEL: 'criticalMinorLevel'
};

export default function InspectionAQL({
  fieldNames = {
    critical: FIELD_NAME.CRITICAL_LEVEL,
    major: FIELD_NAME.MAJOR_LEVEL,
    minor: FIELD_NAME.MINOR_LEVEL
  },
  helperText
}) {
  const { getOptions } = useMasterData();
  const AQLOptions = getOptions(DataType.AQL);
  const { critical, major, minor } = fieldNames;
  // Use the fieldNames variables here if needed

  return (
    <div className={classes.block}>
      <span>
        <Typography.Title className={classes.subTitle} level={4}>
          Inspection AQL
        </Typography.Title>

        {helperText && <p className={classes.helper}>{helperText}</p>}
      </span>

      <Row gutter={[16, 16]} wrap>
        <Col sm={24} lg={8}>
          <Space direction="vertical" className={classes.fullWidth} size={4}>
            <label className={classes.fieldLabel}>Critical Level</label>
            <Field name={critical}>
              {({ field }) => {
                return (
                  <Select
                    options={AQLOptions}
                    placeholder="Select Critical Level"
                    value={field.value}
                    onBlur={field.onBlur}
                    onChange={(option) => {
                      field.onChange({
                        target: { name: field.name, value: option }
                      });
                    }}
                  />
                );
              }}
            </Field>
          </Space>
        </Col>
        <Col sm={24} lg={8}>
          <Space direction="vertical" className={classes.fullWidth} size={4}>
            <label className={classes.fieldLabel}>Major Level</label>
            <Field name={major}>
              {({ field }) => {
                return (
                  <Select
                    options={AQLOptions}
                    placeholder="Select Major Level"
                    value={field.value}
                    onBlur={field.onBlur}
                    onChange={(option) => {
                      field.onChange({
                        target: {
                          name: field.name,
                          value: option
                        }
                      });
                    }}
                  />
                );
              }}
            </Field>
          </Space>
        </Col>
        <Col sm={24} lg={8}>
          <Space direction="vertical" className={classes.fullWidth} size={4}>
            <label className={classes.fieldLabel}>Minor Level</label>
            <Field name={minor}>
              {({ field }) => {
                return (
                  <Select
                    placeholder="Select Minor Level"
                    options={AQLOptions}
                    value={field.value}
                    onBlur={field.onBlur}
                    onChange={(option) => {
                      field.onChange({
                        target: {
                          name: field.name,
                          value: option
                        }
                      });
                    }}
                  />
                );
              }}
            </Field>
          </Space>
        </Col>
      </Row>
    </div>
  );
}

InspectionAQL.propTypes = {
  fieldNames: PropTypes.shape({
    critical: PropTypes.string,
    major: PropTypes.string,
    minor: PropTypes.string
  }),
  helperText: PropTypes.string
};

InspectionAQL.defaultProps = {
  fieldNames: {
    critical: FIELD_NAME.CRITICAL_LEVEL,
    major: FIELD_NAME.MAJOR_LEVEL,
    minor: FIELD_NAME.MINOR_LEVEL
  },
  helperText: ''
};
